import * as React from "react";
import styled, { css } from "styled-components";
import { useState, useCallback, useMemo } from "react";
import { Table, Button } from "components/bootstrap";
import { ProgressBar, SortIcon } from "components/common";
import { defaultCompare } from "logic/DefaultCompare";
import { STEPS } from "security-app/components/common/ThreatCoverageWidget/ImproveCoverageModal/StepsOverview";
import ImproveCoverageButton from "./ImproveCoverageButton";
import { isFullyCovered } from "./Utils";
const Container = styled.div(
  ({ theme }) => css`
    flex: 1;
    min-width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media (max-width: ${theme.breakpoints.max.xl}) {
      height: initial;
      min-height: initial;
    }
  `
);
const TableContainer = styled.div`
  overflow: visible;
`;
const Thead = styled.thead(
  ({ theme }) => css`
    background-color: ${theme.colors.global.contentBackground};
    position: sticky;
    top: 0;
    z-index: 1;
  `
);
const Header = styled.div`
  display: flex;
  align-items: center;
  height: 28px;
`;
const ProgressCell = styled.div`
  display: flex;
`;
const StyledProgressBar = styled(ProgressBar)`
  flex: 1;
  margin: 0;
`;
const CoveragePercentage = styled.div`
  width: 45px;
  text-align: right;
  margin-right: 5px;
`;
const TacticsList = ({ tactics, onSelectTactic = () => {
} }) => {
  const [coverageSortDirection, setCoverageSortDirection] = useState("Ascending");
  const sortedTactics = useMemo(
    () => {
      var _a;
      return (_a = tactics == null ? void 0 : tactics.sort(({ name: name1, coverage: coverage1 }, { name: name2, coverage: coverage2 }) => {
        if (coverage1 !== coverage2) {
          if (coverageSortDirection === "Ascending") {
            return coverage1 - coverage2;
          }
          return coverage2 - coverage1;
        }
        return defaultCompare(name1, name2);
      })) != null ? _a : [];
    },
    [coverageSortDirection, tactics]
  );
  const toggleCoverageSort = useCallback(() => {
    setCoverageSortDirection((cur) => cur === "Ascending" ? "Descending" : "Ascending");
  }, []);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(TableContainer, null, /* @__PURE__ */ React.createElement(Table, null, /* @__PURE__ */ React.createElement(Thead, null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, /* @__PURE__ */ React.createElement(Header, null, "Tactic Name")), /* @__PURE__ */ React.createElement("th", { style: { width: "160px", textAlign: "center" } }, /* @__PURE__ */ React.createElement(Header, null, "Technique Count")), /* @__PURE__ */ React.createElement("th", { style: { width: "160px" } }, /* @__PURE__ */ React.createElement(Header, null, "Coverage", " ", /* @__PURE__ */ React.createElement(
    SortIcon,
    {
      activeDirection: coverageSortDirection,
      onChange: toggleCoverageSort,
      title: `Sort coverage ${coverageSortDirection === "Ascending" ? "descending" : "ascending"}`
    }
  ))))), /* @__PURE__ */ React.createElement("tbody", null, sortedTactics.map((tactic) => {
    const { name, coverage, id, numChildren, numFullyCoveredChildren } = tactic;
    return /* @__PURE__ */ React.createElement("tr", { key: id }, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", onClick: () => onSelectTactic(tactic.id) }, name)), /* @__PURE__ */ React.createElement("td", { style: { textAlign: "center" } }, numFullyCoveredChildren, "/", numChildren), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(ProgressCell, null, /* @__PURE__ */ React.createElement(
      StyledProgressBar,
      {
        bars: [{ value: coverage, bsStyle: isFullyCovered(coverage) ? "success" : "warning" }]
      }
    ), /* @__PURE__ */ React.createElement(CoveragePercentage, null, coverage, "%"), /* @__PURE__ */ React.createElement(
      ImproveCoverageButton,
      {
        coverageEntity: tactic,
        isTactic: true,
        initialStep: STEPS.eventDefinitionsEnable.key
      }
    ))));
  })))));
};
export default TacticsList;
